import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import HistoryDateFilter from "./HistoryDateFilter";
import ShowQuestionModal from "../../../Home/Tracks/ExamView/ShowQuestionModal";
import QuestionView from "../../Question/View/QuestionView";

const UserErrorReportsModal = ({ show, onClose, user, t }) => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState(moment().subtract(6, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [searchText, setSearchText] = useState("");
    const [searchMode, setSearchMode] = useState("date");
    const [count, setCount] = useState(20);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [showQuestionModal, setShowQuestionModal] = useState(false);

    const fetchData = (currentMode = searchMode, start = startDate, end = endDate, cnt = count) => {
        if (!user) return;
        setLoading(true);

        let url = "";
        if (currentMode === "date") {
            url = `/ErrorReport/?userId=${user.Id}&startDate=${start.format('DD/MM/YYYY')}&endDate=${end.format('DD/MM/YYYY')}&count=1000&searchMode=date`;
        } else {
            url = `/ErrorReport/?userId=${user.Id}&count=${cnt}&searchMode=count`;
        }

        api.get(url)
            .then(resp => {
                setReports(resp.data?.data || []);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (show && user) {
            fetchData();
        }
    }, [show, user]);

    const filteredReports = reports.filter(report => {
        if (searchMode === "date") {
            const msgDate = moment(report.CreationDate, "YYYY-MM-DD HH:mm");
            const isWithinDate = msgDate.isBetween(startDate.clone().startOf('day'), endDate.clone().endOf('day'), null, '[]');
            if (!isWithinDate) return false;
        }

        if (!searchText) return true;
        const text = searchText.toLowerCase();
        return (
            (report.Name && report.Name.toLowerCase().includes(text)) ||
            (report.Note && report.Note.toLowerCase().includes(text)) ||
            (report.Question && report.Question.Name && report.Question.Name.toLowerCase().includes(text))
        );
    });

    return (
        <>
            <Modal size="lg" centered show={show} onHide={onClose} className="admin-history-modal" enforceFocus={false}>
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="w-100">
                        <div className="d-flex align-items-center">
                            <div className="history-modal-icon-wrapper ml-3 text-danger">
                                <i className="fad fa-bug"></i>
                            </div>
                            <div className="text-right">
                                <div className="h5 mb-1 font-weight-bold text-dark">{t("Pages.UsersControl.action.errorReports") || "بلاغات الأخطاء"}</div>
                                <div className="small text-muted">{user?.Name}</div>
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-4 pb-4">
                    <HistoryDateFilter
                        startDate={startDate}
                        endDate={endDate}
                        searchMode={searchMode}
                        count={count}
                        searchText={searchText}
                        showSearchModeSelect={true}
                        onApply={(mode, start, end, cnt, search) => {
                            setSearchMode(mode);
                            setStartDate(start);
                            setEndDate(end);
                            setCount(cnt);
                            setSearchText(search);
                            fetchData(mode, start, end, cnt);
                        }}
                        t={t}
                    />

                    {loading ? (
                        <div className="text-center py-5">
                            <i className="fad fa-sync fa-spin fa-2x text-muted mb-2"></i>
                            <div className="text-muted small">{t("Pages.UsersControl.Loading") || "جاري التحميل..."}</div>
                        </div>
                    ) : filteredReports.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                            <i className="fal fa-file-search fa-2x mb-2 d-block"></i>
                            <span>{t("Pages.UsersControl.NotFound") || "لا توجد نتائج"}</span>
                        </div>
                    ) : (
                        <div className="history-modal-list scrollbar-custom mx-0" style={{ direction: 'rtl' }}>
                            {filteredReports.map((report) => (
                                <div key={report.Id} className="w-100 mb-3 compact-history-card">
                                    <div className="compact-history-row align-items-start">
                                        <div className="compact-history-left w-100 flex-column align-items-start">
                                            <div className="d-flex align-items-center justify-content-between w-100 mb-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="compact-history-icon-box" style={{ background: '#fef2f2', color: '#dc2626' }}>
                                                        <i className="fad fa-bug"></i>
                                                    </div>
                                                    <h6 className="compact-history-title mb-0 font-weight-bold text-dark">
                                                        {report.Index && (
                                                            <span className="text-muted small ml-1">{report.Index.Name} &gt; </span>
                                                        )}
                                                        <Link 
                                                            to={`/ControlPanel/Lesson/Edit/${report.LessonId}`} 
                                                            className="text-primary text-decoration-none hover-underline"
                                                            style={{ fontWeight: '700' }}
                                                        >
                                                            {report.Name}
                                                        </Link>
                                                    </h6>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className={`compact-history-badge ${report.IsSolved ? "green" : "red"}`}>
                                                        <i className={`fal ${report.IsSolved ? "fa-check-circle" : "fa-exclamation-circle"} ml-1`}></i>
                                                        {report.IsSolved ? t("Pages.UsersControl.errorReports.Solved") : t("Pages.UsersControl.errorReports.Active")}
                                                    </span>
                                                    {report.IsArchived && (
                                                        <span className="compact-history-badge secondary">
                                                            <i className="fal fa-archive ml-1"></i>
                                                            {t("Pages.UsersControl.errorReports.Archived")}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            {report.Question && (
                                                <div className="mb-2 w-100 text-right pr-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center"
                                                        onClick={() => {
                                                            setSelectedQuestion(report.Question);
                                                            setShowQuestionModal(true);
                                                        }}
                                                        style={{ fontSize: '0.85rem', color: '#0284c7', fontWeight: '600', border: 'none', background: 'none' }}
                                                    >
                                                        <i className="fal fa-question-circle ml-1 text-info"></i>
                                                        <span className="ml-1">{t("Pages.UsersControl.errorReports.Question")}:</span>
                                                        <span className="mr-1" dangerouslySetInnerHTML={{ __html: report.Question.Name }}></span>
                                                    </button>
                                                </div>
                                            )}

                                            <div className="w-100 pr-3 pl-3 py-2 mb-2 bg-light rounded text-right" style={{ borderRight: '3px solid #cbd5e1' }}>
                                                <div className="small text-muted font-weight-bold mb-1">{t("Pages.UsersControl.errorReports.Note")}:</div>
                                                <div 
                                                    className="mb-0 text-dark" 
                                                    style={{ whiteSpace: 'pre-line', fontSize: '0.9rem', lineHeight: '1.5' }}
                                                    dangerouslySetInnerHTML={{ __html: report.Note }}
                                                />
                                            </div>

                                            <div className="d-flex justify-content-end align-items-center w-100 text-muted small mt-2">
                                                <span className="badge badge-light p-2">
                                                    <i className="fal fa-calendar-alt ml-1"></i>
                                                    {report.CreationDate}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0 text-center justify-content-center">
                    <button type="button" className="btn btn-light px-5 py-2" style={{ borderRadius: '10px', fontWeight: '600' }} onClick={onClose}>
                        {t("Close") || "إغلاق"}
                    </button>
                </Modal.Footer>
            </Modal>

            {showQuestionModal && selectedQuestion && (
                <ShowQuestionModal 
                    showResult={true} 
                    handleClose={() => {
                        setShowQuestionModal(false);
                        setSelectedQuestion(null);
                    }}
                    renderQuestionView={() => (
                        <QuestionView
                            question={selectedQuestion}
                            key={selectedQuestion.Id}
                            index={1}
                            showResult={false}
                            onEdit={true}
                            solveButton={false} 
                        />
                    )}
                />
            )}
        </>
    );
};

export default UserErrorReportsModal;
